import React, { useEffect, useState } from "react";
import BannerSlider from "./BannerSlider";
import DesktopBannerSlider from "./DesktopBannerSlider";

const DESKTOP_BREAKPOINT = 1024;

export default function MobileDesktop() {
  const [isMobileOrTablet, setIsMobileOrTablet] = useState(() => {
    if (typeof window === "undefined") {
      return false;
    }

    return window.innerWidth <= DESKTOP_BREAKPOINT;
  });

  useEffect(() => {
    const mediaQuery = window.matchMedia(
      `(max-width: ${DESKTOP_BREAKPOINT}px)`
    );

    const handleScreenChange = (event) => {
      setIsMobileOrTablet(event.matches);
    };

    setIsMobileOrTablet(mediaQuery.matches);

    mediaQuery.addEventListener("change", handleScreenChange);

    return () => {
      mediaQuery.removeEventListener("change", handleScreenChange);
    };
  }, []);

  return (
    <section className="home-hero-section">
      {isMobileOrTablet ? <BannerSlider /> : <DesktopBannerSlider />}
    </section>
  );
}